export default __webpack_public_path__ + "static/media/glr-2.c5ed2a20.webp";